import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../../../core/_base/crud';
import { Category } from '../models';
import { CategoryState } from '../reducers/category.reducer';

export const selectCategoryState = createFeatureSelector<CategoryState>('category');

export const selectCategoryPageLoading = createSelector(
  selectCategoryState,
  (state) => state.pageLoading,
);

export const selectCategoryActionLoading = createSelector(
  selectCategoryState,
  (state) => state.actionLoading,
);

export const selectCategoryShowInitWaitingMessage = createSelector(
  selectCategoryState,
  (state) => state.showInitWaitingMessage,
);

export const selectCategoryError = createSelector(selectCategoryState, (state) => state.error);

export const selectCategoryPage = createSelector(selectCategoryState, (state) => {
  const categories: Category[] = [];
  each(state.ids, (id: number) => categories.push(state.entities[id]));

  return new QueryResultsModel(categories, state.totalCount);
});
